const Logo = ({ ...props }) => <img src="/static/images/brand/logo.svg" alt="Nando’s logo" {...props} />;

export { Logo };
